import { registerQuery } from 'data-fetching-client';
import * as ecosystemClient from '../clients/ecosystemClient';

function getSearchTags({
  offeringType,
  isUngatedForUnifiedSearch = false
}) {
  if (isUngatedForUnifiedSearch) {
    return ecosystemClient.getUnifiedSearchTags(offeringType);
  }

  return ecosystemClient.getSearchTags(Array.isArray(offeringType) ? offeringType[0] : offeringType);
}

export const GET_SEARCH_TAGS = registerQuery({
  fieldName: 'searchTags',
  args: ['offeringType'],
  fetcher: getSearchTags
});